import styled from 'styled-components';
import { Typography } from '@equinor/eds-core-react';
import { theme } from '../../../../tokens/theme';

export const Panel = styled.div<{ $twoCol?: boolean }>`
  flex: 0 1 ${(p) => (p.$twoCol ? '560px' : '280px')};
  min-width: ${(p) => (p.$twoCol ? '360px' : '180px')};
`;

export const ArchelList = styled.div<{ $twoCol: boolean }>`
  display: grid;
  grid-template-columns: ${(p) => (p.$twoCol ? '1fr 1fr' : '1fr')};
  gap: ${(p) => (p.$twoCol ? '0 20px' : '0')};
`;

export const PanelTitle = styled(Typography).attrs({ variant: 'h6' })`
  margin-bottom: 14px;
`;

export const HintText = styled(Typography).attrs({ variant: 'body_short' })`
  color: ${theme.light.text.staticIconsTertiary};
  margin-top: 6px;
`;

export const ArchelRow = styled.div`
  margin-bottom: 12px;
`;

export const ArchelLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
`;

export const ColorSwatch = styled.div<{ $color: string }>`
  width: 11px;
  height: 11px;
  border-radius: 2px;
  flex-shrink: 0;
  background: ${(p) => p.$color};
`;

/** Archel name — truncates with ellipsis; Tooltip shows the full name. */
export const ArchelName = styled(Typography).attrs({ variant: 'body_short' })`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
`;

export const DiffLabel = styled.span<{ $positive: boolean; $neutral: boolean }>`
  font-size: 11px;
  font-weight: 600;
  margin-left: 2px;
  color: ${(p) =>
    p.$neutral
      ? theme.light.text.staticIconsTertiary
      : p.$positive
      ? '#358132' /* interactive.success__text */
      : theme.light.danger.text};
`;

export const BarTrack = styled.div<{ $dimmed: boolean }>`
  background: ${theme.light.ui.background.medium};
  border-radius: 3px;
  height: 13px;
  position: relative;
  overflow: hidden;
  margin-bottom: 2px;
  opacity: ${(p) => (p.$dimmed ? 0.35 : 1)};
  transition: opacity 0.2s;
`;

export const BarFill = styled.div<{ $pct: number; $color: string }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${(p) => p.$pct}%;
  background: ${(p) => p.$color};
  border-radius: 3px;
  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const BarPct = styled.span`
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
  pointer-events: none;
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 14px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendBarTrack = styled.div`
  background: ${theme.light.ui.background.medium};
  border-radius: 3px;
  height: 12px;
  width: 72px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
`;

export const LegendBarFill = styled.div<{ $color: string }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 65%;
  background: ${(p) => p.$color};
  border-radius: 3px;
`;

export const LegendLabel = styled(Typography).attrs({ variant: 'caption' })`
  color: ${theme.light.text.staticIconsTertiary};
`;
